import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { GeoProvider } from "./context/GeoContext";
import Navigation from "./components/Navigation";
import LpNavigation from "./components/LpNavigation";
import Footer from "./components/Footer";
import LpFooter from "./components/LpFooter";
import { Toaster } from "./components/ui/toaster";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import TrademarkRegister from "./pages/services/TrademarkRegister";
import CopyrightRegister from "./pages/services/CopyrightRegister";
import PatentApplication from "./pages/services/PatentApplication";
import LLCFormation from "./pages/services/LLCFormation";
import GenericService from "./pages/GenericService";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import News from "./pages/News";
import NewsArticle from "./pages/NewsArticle";
import Publications from "./pages/Publications";
import PublicationDetail from "./pages/PublicationDetail";
import ThankYou from "./pages/ThankYou";
import LandingPage from "./pages/LandingPage";

function AppContent() {
  const location = useLocation();
  const isLp = location.pathname === '/lp';
  const isThankYou = location.pathname.startsWith('/application/');

  return (
    <>
      {!isThankYou && (isLp ? <LpNavigation /> : <Navigation />)}
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lp" element={<LandingPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Trademark Services */}
          <Route path="/services/trademark/register" element={<TrademarkRegister />} />
          <Route path="/services/trademark/:service" element={<GenericService />} />
          
          {/* Copyright Services */}
          <Route path="/services/copyright/register" element={<CopyrightRegister />} />
          <Route path="/services/copyright/:service" element={<GenericService />} />
          
          {/* Patent Services */}
          <Route path="/services/patent/application" element={<PatentApplication />} />
          <Route path="/services/patent/:service" element={<GenericService />} />
          
          {/* Company Formation */}
          <Route path="/services/company/llc" element={<LLCFormation />} />
          <Route path="/services/company/:service" element={<GenericService />} />
          
          {/* Legal Services */}
          <Route path="/services/legal/:service" element={<GenericService />} />
          
          {/* Additional Services */}
          <Route path="/services/additional/:service" element={<GenericService />} />
          
          {/* Media Center */}
          <Route path="/resources/blogs" element={<Blog />} />
          <Route path="/resources/blogs/:slug" element={<BlogPost />} />
          <Route path="/resources/news" element={<News />} />
          <Route path="/resources/news/:slug" element={<NewsArticle />} />
          <Route path="/resources/publications" element={<Publications />} />
          <Route path="/resources/publications/:slug" element={<PublicationDetail />} />
          <Route path="/media/:type" element={<GenericService />} />
          
          {/* Legal Pages */}
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          
          {/* Thank You / Application */}
          <Route path="/application/main" element={<ThankYou />} />
          
          {/* Catch-all for undefined routes */}
          <Route path="*" element={<Home />} />
      </Routes>
      {!isThankYou && (isLp ? <LpFooter /> : <Footer />)}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
